import { render, staticRenderFns } from "./ResultsTable.vue?vue&type=template&id=5de44e77&"
import script from "./ResultsTable.vue?vue&type=script&lang=js&"
export * from "./ResultsTable.vue?vue&type=script&lang=js&"
import style0 from "./ResultsTable.vue?vue&type=style&index=0&id=5de44e77&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports